import { createSlice } from '@reduxjs/toolkit';
import SectionNavId from './SectionNavId';

export type TrailPageState = {
  activeSection: SectionNavId;
  /** Set by an entry point that has no map of its own, which opens the print modal on its own */
  isPrintRequested?: boolean;
  isScrollingViaTabs?: boolean;
  isTrailMapOpen?: boolean;
  viewLimitReached: 'uninitialized' | boolean;
};

export const initialState: TrailPageState = {
  activeSection: 'overview',
  isPrintRequested: false,
  isScrollingViaTabs: false,
  isTrailMapOpen: false,
  viewLimitReached: 'uninitialized'
};

export const trailPageSlice = createSlice({
  name: 'trailPage',
  initialState,
  reducers: {
    setActiveSection: (state, action: { payload: SectionNavId }) => {
      state.activeSection = action.payload;
    },
    setIsScrollingViaTabs: (state, action: { payload: boolean }) => {
      state.isScrollingViaTabs = action.payload;
    },
    requestPrint: state => {
      state.isPrintRequested = true;
    },
    clearPrintRequest: state => {
      state.isPrintRequested = false;
    },
    setIsTrailMapOpen: (state, action: { payload: boolean }) => {
      state.isTrailMapOpen = action.payload;
      if (action.payload) {
        state.isPrintRequested = false;
      }
    },
    setViewLimitReached: (state, action: { payload: boolean }) => {
      state.viewLimitReached = action.payload;
    }
  }
});

export const { clearPrintRequest, requestPrint, setActiveSection, setIsScrollingViaTabs, setIsTrailMapOpen, setViewLimitReached } =
  trailPageSlice.actions;
export default trailPageSlice.reducer;
